import styled from 'styled-components';

export const TopicsContainer = styled.section`
  margin-top: 2rem;
`;

export const ItemsAmountRow = styled.div`
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
`;
